import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { HttpClient } from '@angular/common/http';
import { LoginService } from '../services/loginservice.service';

@Component({
  selector: 'app-verify-email',
  templateUrl: './verify-email.component.html',
  styleUrls: ['./verify-email.component.css']
})
export class VerifyEmailComponent implements OnInit {
  token: string;
  istokenvalid = false;

  constructor(private loginService: LoginService, private http: HttpClient, private route: ActivatedRoute) {
    this.route.params.subscribe(params => { this.token = params.tokens; console.log(params); });
  }

  ngOnInit() {

    this.loginService.isTokenValid(this.token).subscribe(data => {
      console.log(data);
      if (data && data.status === 'Error') {
        this.istokenvalid = false;
      } else {
        this.istokenvalid = true;
      }
    });

  }

}
